// extracted by mini-css-extract-plugin
export var cardLayout = "_5x-1";
export var paginationContainer = "_5x-0";